import { render, staticRenderFns } from "./aboutUsTable.vue?vue&type=template&id=1f441e5b"
import script from "./aboutUsTable.vue?vue&type=script&lang=js"
export * from "./aboutUsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports